import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AddIcon from "@material-ui/icons/Add";
import FilterList from "@material-ui/icons/FilterList";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import Collapse from "@material-ui/core/Collapse";
import GetApp from "@material-ui/icons/GetApp";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import dateFormat from "dateformat";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import DatePicker from "react-datepicker";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// @material-ui/lab components
// @material-ui/icons components
// core components

import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { redirectToLogout,getDayIdText,numericSortFunc } from "common/SharedFn";
import { getAllSlots,deleteSlot,addSlot,updateSlot, getAllActiveDrivers,getAllLaundries } from "../../network/ApiAxios";
import {  Delete, Edit } from "@material-ui/icons";
import "react-datepicker/dist/react-datepicker.css";
import 'react-calendar/dist/Calendar.css';
import 'assets/css/doobi.css';


const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage:50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const AvailabilitySlotsTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  // Filters open on request rather than always taking a row
  const [showFilters, setShowFilters] = useState(false);
  const [alert, setAlert] = React.useState(false);
  const [drivers, setDrivers] = useState([]);
  const [laundries, setLaundries] = useState([]); 
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [bookedSlots, setBookedSlots] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [selectedDate, setSelectedDate] = useState();
  const [isLoadingBookedSlots, setIsLoadingBookedSlots] = useState(false);
  const [bookedSlotsUpdated, setBookedSlotsUpdated] = useState(false);
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [addModal, setAddModal] = useState(false);
  const [bookedSlotsModal, setBookedSlotsModal] = useState(false); 
  const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState();
  const [dayId, setDayId] = useState(1);
  const [numberOfConcurrentBookings, setNumberOfConcurrentBookings] = useState(1);
  const [deliveryType, setDeliveryType] = useState(0);
  const [turnAroundTime, setTurnAroundTime] = useState("");
  const [proTurnAroundTime, setProTurnAroundTime] = useState("");
  const [driverId, setDriverId] = useState(0);
  const [laundryId, setLaundryId] = useState(0);
  const [isSubscription, setIsSubscription] = useState(0);
  const [blocks, setBlocks] = useState("");
  const [cities, setCities] = useState("")
  const [restrictedToRoad, setRestrictedToRoad] = useState("");
  const [restrictedToBuilding, setRestrictedToBuilding] = useState("");
  const [id, setId] = useState();
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [executeDelete, setExecuteDelete] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(true);
  const [forceRefreshBookedSlots, setForceRefreshBookedSlots] = useState(false);
  const [isSubscriptionSlots, setIsSubscriptionSlots] = useState(0);
  let history = useHistory();
  
  const warningAlert = (title,message,action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const getTimeOnly = (datetime) => {
    return dateFormat(
      new Date(datetime),
      "HH:MM:ss"
    )
  }

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const setCurrentRecord = (info) => {
    const { id, dayId,startTime,endTime,numberOfConcurrentBookings,deliveryType,driverId,laundryId, city, blocks,restrictedToRoad,restrictedToBuilding,isSubscription,turnAroundTime,proTurnAroundTime} = info;
    setDayId(dayId);
    setStartTime(new Date("1970-01-01T"+startTime));
    setEndTime(new Date("1970-01-01T"+endTime));
    setNumberOfConcurrentBookings(numberOfConcurrentBookings);
    setDeliveryType(deliveryType);
    setDriverId(driverId);
    setLaundryId(laundryId);
    setBlocks(blocks);
    setCities(city);
    setRestrictedToRoad(restrictedToRoad);
    setRestrictedToBuilding(restrictedToBuilding);
    setTurnAroundTime(turnAroundTime);
    setProTurnAroundTime(proTurnAroundTime);
    setIsSubscription(isSubscription);
    setId(id);
  };

  const clearCurrentRecord = () => {

    setDayId(1);
  setStartTime();
  setEndTime();
  setBlocks("");
  setRestrictedToRoad("");
  setRestrictedToBuilding("");
  setNumberOfConcurrentBookings(1);
  setDeliveryType(0);
  setDriverId(0);
  setLaundryId(0);
  setTurnAroundTime(0);
  setProTurnAroundTime(0);
  setIsSubscription(0);
    setId();
  };


  const accessSlotsUtilizationPage = () => {
    let history = createHistory();
    history.push("/admin/availability-slots/utilization");
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };
  
  const accessSchedulingPage = () => {
    let history = createHistory();
    history.push("/admin/availability-slots/schedule");
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };


  const fetchSlots = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try{
    const response = await getAllSlots();
    const { data } = response;
    const responseDrivers = await getAllActiveDrivers();
    const responseLaundries = await getAllLaundries();
    if (data.result.isSuccess) {
      setDrivers(responseDrivers.data.data);
      setLaundries(responseLaundries.data.data);
      setData(data.data.map((prop) => {
        if(prop.isSubscription === isSubscriptionSlots){
        return makeTableRow(prop);}
        else{
          return '';
        }}
        ));
      //setError("");
    } else {
      showErrorNotification(data.result.description);
      if(data.result.code == -2){
        redirectToLogout();
      }
    }
    }
    catch(ex){
      showErrorNotification("Failed to fetch slots");
    }
    setIsLoading(false);
  };



  const addSlotAction = async () => {
    setIsLoading(true);
    try{
      var driverIdToSend = driverId;
      if(driverIdToSend == 0){
        driverIdToSend = null;
      }
      var laundryIdToSend = laundryId;
      if(laundryIdToSend == 0){
        laundryIdToSend = null;
      }

    const response = await addSlot(dayId,getTimeOnly(startTime),getTimeOnly(endTime),numberOfConcurrentBookings,deliveryType,driverIdToSend,laundryIdToSend,cities, blocks,restrictedToRoad,restrictedToBuilding,isSubscription,turnAroundTime,proTurnAroundTime);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Slot Added Successfully");
      setAddModal(false);
      setForceRefresh(true);
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to add slot");
      setIsLoading(false);
    }
  };


  const updateSlotAction = async () => {
    setExecuteUpdate(false);
    setIsLoading(true);
    try{
      var driverIdToSend = driverId;
      if(driverIdToSend == 0){
        driverIdToSend = null;
      }
      var laundryIdToSend = laundryId;
      if(laundryIdToSend == 0){
        laundryIdToSend = null;
      }
    const response = await updateSlot(id,dayId,getTimeOnly(startTime),getTimeOnly(endTime),numberOfConcurrentBookings,deliveryType,driverIdToSend,laundryIdToSend,cities, blocks,restrictedToRoad,restrictedToBuilding,isSubscription,turnAroundTime,proTurnAroundTime);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Slot Updated Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to update slot");
      setIsLoading(false);
    }
  };


  const deleteParam = async () => {
    setExecuteDelete(false);
    setIsLoading(true);
    try{
    const response = await deleteSlot(id);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Slot Deleted Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to delete slot");
      setIsLoading(false);
    }
  };

  useAsyncEffect(async () => {
    if(executeUpdate){
        updateSlotAction();
    }
    else if(executeDelete){
      deleteParam();
    }
    else if(forceRefresh){
      fetchSlots();
    }
  }, [executeUpdate,forceRefresh,executeDelete,driverId]);

  const makeTableRow = (info) => {
    if(info.deliveryType === 0){
      info.deliveryTypeText = "Pickup";
    }
    else if(info.deliveryType === 1){
      info.deliveryTypeText = "Dropoff";
    }
    else if(info.deliveryType === 3){
      info.deliveryTypeText = "Welcome Kit";
    }
    else{
      info.deliveryTypeText = "Any";
    }
    if(info.isSubscription === 1){
      info.isSubscriptionText = "Yes";
    }
    else{
      info.isSubscriptionText = "No";
    }

    info.dayText = getDayIdText(info.dayId);
    if(info.driverByDriverId != null){
      info.driverText = info.driverByDriverId.fullNameEn;
    }
    
    if(info.laundryByLaundryId != null){
      info.laundryText = info.laundryByLaundryId.name;
    }
    

    return {
      ...info,
      actions: (
        <div className="actions-right">
          <Tooltip title="Edit">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedWarning,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                setCurrentRecord(info);
                setAddModal(true);
            }}>
              <Box component={Edit} />
            </Button>
          </Tooltip>
          <div style={{ display: "inline-block" }}>
          <Tooltip title="Delete">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedError,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Delete Slot","Are you sure you would like to delete the slot with id "+info.id+"?",async () =>  {
                    setCurrentRecord(info);
                    setAlert(null);
                    setExecuteDelete(true);
                  })}}
                >
                  <Box component={Delete} />
                </Button>
              </Tooltip>
              </div>
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >

        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>

              <div style={{width: "100%"}}>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "id",
                    text: "ID",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "dayText",
                    text: "Day",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "startTime",
                    text: "Start Time",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "endTime",
                    text: "End Time",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "isSubscriptionText",
                    text: "Is Subscription Slot",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "deliveryTypeText",
                    text: "Type",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "blocks",
                    text: "Blocks",
                    // sort: true,
                    // sortFunc: numericSortFunc,
                    headerStyle: {display : "none"},
                    style : {display : "none"}        
                  },
                  {
                    dataField: "restrictedToRoad",
                    text: "Roads",
                    // sort: true,
                    // sortFunc: numericSortFunc,
                    headerStyle: {display : "none"},
                    style : {display : "none"}        
                  },
                  {
                    dataField: "restrictedToBuilding",
                    text: "Buildings",
                    // sort: true,
                    // sortFunc: numericSortFunc,
                    headerStyle: {display : "none"},
                    style : {display : "none"}        
                  },
                  {
                    dataField: "numberOfConcurrentBookings",
                    text: "Number of Concurrent Bookings",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "turnAroundTime",
                    text: "Turn Around Time",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "proTurnAroundTime",
                    text: "Pro Turn Around Time",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "driverText",
                    text: "Driver",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "laundryText",
                    text: "Laundry",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "actions",
                    classes: "actions-col",
                    headerClasses: "actions-col",
                    text: "Actions",
                    csvExport: false,
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                                    <>
                  <CardHeader
                    style={{ paddingTop: "0.875rem", paddingBottom: "0.875rem" }}
                    title={
                      <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                        <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Availability Slots</Box>
                    </Box>
                        </>
                        <Tooltip title="Add new slot">
                          <IconButton
                            size="small"
                            onClick={() => {
                              clearCurrentRecord();
                              setAddModal(true);}}
                            style={{
                              width: 32, height: 32,
                              backgroundColor: "#fff",
                              border: "1px solid #5e72e4",
                              color: "#5e72e4",
                            }}
                          >
                            <AddIcon style={{ width: 18, height: 18 }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    }
                    action={
                      <Box
                        display="flex" alignItems="center" flexWrap="wrap"
                        justifyContent="flex-end"
                        style={{ gap: 8, marginTop: 8, marginRight: 8 }}
                      >
                        <div
                          id="datatable-basic_filter"
                          style={{ display: "flex", alignItems: "center", height: 40 }}
                        >
                          <SearchBar
                            className="form-control-sm"
                            placeholder="Search..."
                            style={{ height: 40, margin: 0, boxSizing: "border-box" }}
                            {...props.searchProps}
                          />
                        </div>
                        <Tooltip
                          title={"Slots Utilization"}
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedError,
                            }}
                            onClick={() => {
                              accessSlotsUtilizationPage();
                            }}
                          >
                            <span>Slots Utilization</span>
                          </Button>
                        </Tooltip>

                        <Tooltip
                          title="Booked Slots Calendar"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedSuccess,
                            }}
                            onClick={() => {
                              accessSchedulingPage();
                              // setSelectedDate(new Date());
                              // setDriverId(0);
                              // setLaundryId(0);
                              // fetchBookedSlots(new Date(),0);
                              // setBookedSlotsModal(true);
                            }}
                          >
                            <span>Scheduling</span>
                          </Button>
                        </Tooltip>
                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                        {/* </Tooltip> */}
                        <Tooltip title="Download CSV">
                          <span style={{ display: "flex" }}>
                            <ExportCSVButton
                              className="MuiButtonBase-root"
                              style={{
                                width: 40, height: 40, padding: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                border: "1px solid #172b4d", borderRadius: 8,
                                color: "#fff", backgroundColor: "#172b4d", cursor: "pointer",
                              }}
                              {...props.csvProps}
                            >
                              <GetApp style={{ width: 18, height: 18 }} />
                            </ExportCSVButton>
                          </span>
                        </Tooltip>
                        <Tooltip title={showFilters ? "Hide filters" : "Filters"}>
                          <IconButton
                            onClick={() => setShowFilters((open) => !open)}
                            aria-expanded={showFilters}
                            aria-label="Filters"
                            style={{
                              width: 40, height: 40,
                              border: "1px solid #dee2e6", borderRadius: 8,
                              color: showFilters ? "#5e72e4" : "#525f7f",
                              backgroundColor: showFilters ? "#eef0fb" : "transparent",
                            }}
                          >
                            <FilterList style={{ width: 18, height: 18 }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    }
                  />
                  <div className="table-responsive">
                                        <Collapse in={showFilters}>
                      <Divider />
                      <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <form>
                          <div
                            style={{
                              display: "inline-block",
                              marginBottom: "20px",
                            }}
                          >
                            Filter by 
                            <Select
                              variant="outlined"
                              value={isSubscriptionSlots}
                              onChange={(e) => {
                                setIsSubscriptionSlots(e.target.value);
                                setForceRefresh(true);
                              }}
                              IconComponent={KeyboardArrowDown}
                            >
                              <MenuItem value={0}>Order Slots</MenuItem>
                              <MenuItem value={1}>Subscription Slots</MenuItem>
                            </Select>
                          </div>
                        </form>
                      </Grid>
                    </Grid>
                    </Collapse>
                    
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      //filter={ filterFactory() }
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                    
                  </div>
                                      </>
                )}
              </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Dialog
                classes={{
                  root: classes.center + " " + classes.modalRoot,
                  paper: classes.modal + " " + classes.modalSmall,
                }}
                open={addModal && !isLoading}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setAddModal(false)}
              >
                <DialogTitle
                  disableTypography
                  className={classes.modalHeader}
                >
                  <h4 className={classes.modalTitle}>
                    {id == null || id === "" ? "Add" : "Edit"} Slot
                  </h4>
                </DialogTitle>
                <DialogContent
                  className={classes.modalBody + " " + classes.modalSmallBody}
                >
                  <form>

                  <FormGroup>
                  <FormLabel>Day</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={dayId} onChange={(e) => setDayId(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={1}>Sunday</MenuItem>
                      <MenuItem value={2}>Monday</MenuItem>
                      <MenuItem value={3}>Tuesday</MenuItem>
                      <MenuItem value={4}>Wednesday</MenuItem>
                      <MenuItem value={5}>Thursday</MenuItem>
                      <MenuItem value={6}>Friday</MenuItem>
                      <MenuItem value={7}>Saturday</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>

                <FormGroup>
                  <FormLabel>Start Time</FormLabel>
                <DatePicker
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Start Time"
                    selected={startTime}
                    fullWidth
                    customInput={<OutlinedInput fullWidth/>}
                    onChange={(date) => setStartTime(date)}
                    dateFormat="HH:mm:ss"
                  />
                  </FormGroup>

                  <FormGroup>
                  <FormLabel>End Time</FormLabel>
                <DatePicker
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="End Time"
                    selected={endTime}
                    fullWidth
                    customInput={<OutlinedInput fullWidth/>}
                    onChange={(date) => setEndTime(date)}
                    dateFormat="HH:mm:ss"
                  />
                  </FormGroup>

                <FormGroup>
                  <FormLabel>Number of Concurrent Bookings</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="Concurrent Bookings"
                    value={numberOfConcurrentBookings ?? ""}
                    onChange={(e) => setNumberOfConcurrentBookings(e.target.value)}
                  />
                </FormGroup>


                <FormGroup>
                  <FormLabel>Type</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={isSubscription == 0 ? deliveryType : 2} disabled={isSubscription === 1} onChange={(e) => setDeliveryType(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={0}>Pickup</MenuItem>
                      <MenuItem value={1}>Dropoff</MenuItem>
                      <MenuItem value={3}>Welcome Kit</MenuItem>
                      <MenuItem value={2}>Any</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>

                <FormGroup>
                  <FormLabel>Turn around time in hours</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="Turn around time"
                    value={turnAroundTime ?? ""}
                    onChange={(e) => setTurnAroundTime(e.target.value)}
                  />
                </FormGroup>


                <FormGroup>
                  <FormLabel>Pro Turn around time in hours</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="Pro turn around time"
                    value={proTurnAroundTime ?? ""}
                    onChange={(e) => setProTurnAroundTime(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Cities (Comma seperated or empty for no restriction)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Cities (Comma seperated)"
                    value={cities ?? ""}
                    onChange={(e) => setCities(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Blocks (Comma seperated or empty for no restriction)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Blocks (Comma seperated)"
                    value={blocks ?? ""}
                    onChange={(e) => setBlocks(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Roads (Comma seperated - Required if buildings is not empty)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Roads (Comma seperated)"
                    value={restrictedToRoad ?? ""}
                    onChange={(e) => setRestrictedToRoad(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Buildings (Comma seperated - Required if roads is not empty)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Buildings (Comma seperated)"
                    value={restrictedToBuilding ?? ""}
                    onChange={(e) => setRestrictedToBuilding(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Is Subscription Slot</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={isSubscription} onChange={(e) => setIsSubscription(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={0}>No</MenuItem>
                      <MenuItem value={1}>Yes</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <FormLabel>Driver</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={driverId} onChange={(e) => setDriverId(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={0}>None</MenuItem>
                    {drivers.map(function(driver, i){
                        return <MenuItem value={driver.id}>{driver.fullNameEn}</MenuItem>;
                    })}
                    </Select>
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <FormLabel>Laundry</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={laundryId} onChange={(e) => setLaundryId(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={0}>None</MenuItem>
                    {laundries.map(function(laundry, i){
                        return <MenuItem value={laundry.id}>{laundry.name}</MenuItem>;
                    })}
                    </Select>
                  </FormControl>
                </FormGroup>
                  </form>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setAddModal(false)}
                  >
                    Cancel
                  </Button>
                    <Button
                      onClick={() =>
                        id == null || id === "" ? addSlotAction() : updateSlotAction()
                      }
                      
                  classes={{
                    root: classes.buttonContainedPurple100,
                  }}
                      variant="contained"
                    >
                      {id == null || id === "" ? "Add" : "Update"}
                    </Button>
                  
                </DialogActions>
              </Dialog>

        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default AvailabilitySlotsTable;
